import { useEffect, useState } from "react";

const navLinks = [
  { href: "#top", label: "首页" },
  { href: "#address", label: "最新地址" },
  { href: "#troubleshoot", label: "打不开怎么办" },
  { href: "#official", label: "官网入口" },
  { href: "#app", label: "App 下载" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
          </span>
          <span
            className={`font-heading text-lg tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            八戒影院
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100"
                  : "text-background-50/90 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-background-50"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block px-3 py-3 text-sm text-foreground-700 rounded-md hover:bg-background-100 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}